
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { siteUrl } from 'constants/app';
import SEO from 'global/SEO';
import dynamic from 'next/dynamic';

const ProTools = dynamic(() => import('features/pro-tools'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function ProToolsPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Professional Tools Saham Bahkan Untuk Pemula"
        description="Fitur Stockbit Pro memudahkan investor untuk melakukan analisa saham dengan berbagai alat analisa dan data yang lengkap. Cari saham sesuai kriteria kamu, analisa, beli sahamnya dan lihat pergerakannya secara real time."
        url={`${siteUrl}/info/pro-tools`}
      />
      <ProTools />
    </HomePageLayout>
  );
}

export default ProToolsPage;
